import { render, staticRenderFns } from "./OrderMade.vue?vue&type=template&id=a36c32c4&scoped=true"
import script from "./OrderMade.vue?vue&type=script&lang=js"
export * from "./OrderMade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36c32c4",
  null
  
)

export default component.exports